<app-dialog-header
  [title]="'Umbuchung'"
  [dialogRef]="dialogRef"
  (close)="onCancel()"
/>

<mat-dialog-content>
  <div [formGroup]="form">
    <div style="display: flex; gap: 0.5rem">
      <kpi4me-date-element label="von" [formControlElement]="form.controls.fromDate"/>
      <kpi4me-date-element label="bis" [formControlElement]="form.controls.toDate"/>
    </div>

    <mat-slide-toggle [color]="'primary'" style="padding: 0.5rem 0" formControlName="rebookAll">Alle umbuchen
    </mat-slide-toggle>
  </div>
</mat-dialog-content>

<div mat-dialog-actions style="margin-top:1rem;">
  <app-confirm-icon-button
    [disabled]="form.invalid"
    (customClick)="onConfirm()"/>
</div>
